/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import NutritionPlan from './nutrition-plan';
import NutritionPlanDetail from './nutrition-plan-detail';
import NutritionPlanUpdate from './nutrition-plan-update';
import NutritionPlanDeleteDialog from './nutrition-plan-delete-dialog';

const NutritionPlanRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<NutritionPlan />} />
    <Route path="new" element={<NutritionPlanUpdate />} />
    <Route path=":id">
      <Route index element={<NutritionPlanDetail />} />
      <Route path="edit" element={<NutritionPlanUpdate />} />
      <Route path="delete" element={<NutritionPlanDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default NutritionPlanRoutes;
